import React from 'react';
import { connect } from 'react-redux';
import AirportSpotSummary from 'common/facility-summary-airport/v1';
import StarRatingWithCategory from 'common/star-rating-with-category';
import Image from 'common/image';
import BenefitMessage from '../benefit-message';
import useConfig from 'hooks/use-config';
export const SpotDetailsHeader = ({ facility, percentLowerPrice, isAdmin, linearMeters, walkingMeters, showBenefitMessage = false, }) => {
    const { staticBaseUrl } = useConfig();
    const { id, title, logos, images, rating_info: ratingInfo, airport, amenities_full: amenitiesList, } = facility;
    const { details: { code: iataCode }, } = airport;
    const { number_of_ratings: numberOfReviews, star_rating: starRating, } = ratingInfo;
    const logoId = logos && logos.length > 0
        ? logos[0].id
        : images && images.length > 0
            ? images[0].id
            : null;
    const logoProps = {
        width: 144,
        height: 144,
        alt: `Photo of ${title}`,
        ...(logoId
            ? { cloudinaryImageId: logoId }
            : { src: `${staticBaseUrl}img/missing-image.png` }),
    };
    return (<div className="SpotDetailsHeader">
            <div className="SpotDetailsHeader-top-content">
                <div className="SpotDetailsHeader-photo">
                    <Image {...logoProps}/>
                </div>
                <div className="SpotDetailsHeader-details">
                    {showBenefitMessage && (<BenefitMessage percentLowerPrice={percentLowerPrice} iataCode={iataCode}/>)}
                    <h2 itemProp="name">{unescape(title)}</h2>
                    <StarRatingWithCategory numberOfReviews={numberOfReviews} starRating={starRating}/>
                    {isAdmin && (<a className="SpotDetailsHeader-admin-link" href={`/admin/spots/${id}`} target="_blank" rel="noopener noreferrer">
                            Facility Admin Page
                        </a>)}
                    <AirportSpotSummary data={airport} amenities={amenitiesList} linearMeters={linearMeters} walkingMeters={walkingMeters}/>
                </div>
            </div>
            <div className="SpotDetailsHeader-bottom-content">
                <AirportSpotSummary data={airport} amenities={amenitiesList} linearMeters={linearMeters} walkingMeters={walkingMeters}/>
            </div>
        </div>);
};
const mapStateToProps = state => {
    const { user: { data: { isAdmin }, }, } = state;
    return {
        isAdmin,
    };
};
export default connect(mapStateToProps)(SpotDetailsHeader);
